

import $ from 'jquery';
import 'foundation-sites';
import { StringTune } from "@fiddle-digital/string-tune";

import navigationMenu from './menu';
import sliderGrand from './slider';
import textAnimation from './text';
import uspsAnimation from './usps';
import initCustomSelects from './select'
import pdpInteractivity from './pdp'
import cartInteractivity from './cart'
import checkoutInteractivity from './checkout'
import orderForm from "./orderForm";

window.$ = $;
window.jQuery = $;

const stringTune = StringTune.getInstance();
stringTune.speed = 0.3;
stringTune.speedAccelerate = 0.4;
stringTune.start(60);

$(document).ready(() => {
    const isDesktop = Foundation.MediaQuery.atLeast('xxlarge');

    $(document).foundation();

    navigationMenu();
    sliderGrand();
    textAnimation();
    initCustomSelects();
    pdpInteractivity();
    cartInteractivity();
    checkoutInteractivity();

    if (document.querySelector('.orderform')) {
        orderForm();
    }

    if (isDesktop) {
        uspsAnimation();
    }

    updateViewportAttribute()
    $(window).on('resize', updateViewportAttribute);

    $('a.js-anchor').click(function (e) {
        e.preventDefault();
        var target = $(this).data('target');

        $('html, body').animate({ scrollTop: $(target).offset().top }, 'slow');
    });

    $('.order-overview .button').on('click', function () {
        const $orders = $('.orders-grid');
        const $button = $(this);

        $orders.toggleClass('show-all');

        const isShown = $orders.hasClass('show-all');
        $button.text(isShown ? 'Show less' : 'All orders');
    });

});


function updateViewportAttribute() {
    const width = $(window).width();
    const $body = $('body');

    const breakpoints = {
        small: 0,
        medium: 640,
        large: 768,
        xlarge: 1024,
        xxlarge: 1281,
        xxxlarge: 1440,
        xxxxlarge: 1750,
        xxxxxlarge: 2100,
        xxxxxxlarge: 2600
    };

    let current = 'small';
    $.each(breakpoints, function (key, value) {
        if (width >= value) {
            current = key;
        }
    });

    $body.attr('data-viewport', current);
}